import React from 'react';
import { motion } from 'framer-motion';
import { DatabaseIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
export function PlatformFeatures() {
  const pillars = [{
    icon: DatabaseIcon,
    title: 'Context',
    subtitle: 'How agents take action.',
    desc: 'MCPs into EHRs, payers, clearinghouses, labs, and pharmacy networks. Normalized, action-capable, agent-ready.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Governance',
    subtitle: 'How agents earn trust.',
    desc: 'Agent identity, scoped permissions, and full audit trails built for HIPAA from day one.'
  }, {
    icon: ActivityIcon,
    title: 'Quality',
    subtitle: 'How agents stay reliable at scale.',
    desc: 'Evals, observability, and traces that surface hallucinations, regressions, and silent failures before patients or providers do.'
  }];
  return <section id="platform" className="py-24 bg-hubble-card/30 relative z-10 border-y border-hubble-border/50" data-id="element-145">
      <div className="max-w-7xl mx-auto px-6" data-id="element-146">
        <div className="text-center mb-16" data-id="element-147">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-148">
            PLATFORM
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text mb-4" data-id="element-149">
            Three layers. One integration.
          </h2>
          <p className="font-body text-[16px] md:text-[18px] text-hubble-body max-w-2xl mx-auto leading-[1.6]" data-id="element-150">
            Everything a healthcare AI agent needs to reach production.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-151">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-primary/50 transition-colors group relative overflow-hidden" data-id="element-152">
              <div className="absolute inset-0 bg-gradient-to-br from-hubble-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-153"></div>

              <div className="relative z-10" data-id="element-154">
                <div className="w-12 h-12 rounded-xl bg-hubble-primary/10 border border-hubble-primary/20 flex items-center justify-center mb-6" data-id="element-155">
                  <pillar.icon className="w-6 h-6 text-hubble-accent" data-id="element-156" />
                </div>
                <h3 className="font-heading text-2xl font-medium text-hubble-text mb-1" data-id="element-157">
                  {pillar.title}
                </h3>
                <p className="font-body text-sm text-hubble-accent mb-4" data-id="element-158">
                  {pillar.subtitle}
                </p>
                <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-159">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}